import axios from 'axios'
// import router from '@/router' // 根据你的路由路径调整
import { AXIOS_API } from '@/views/storege/index'
import {message} from 'ant-design-vue'
// const message = (value) => {
//     notification.info({
//         message: 'Check for updates automatically',
//         description: value,
//         duration: 10,
//     })
// }

// 创建自定义实例
const axios_service = axios.create({
    // baseURL: AXIOS_API
})

// 请求拦截器
axios_service.interceptors.request.use(
    (config) => {
        // 添加认证 token
        const token = sessionStorage.getItem('Authorization')
        if (token) {
            config.headers.Authorization = `${token}`
        }
        return config
    }
)

// 响应拦截器
axios_service.interceptors.response.use(
    response => {
        // 统一处理业务逻辑
        const response_data = response
        if (response_data.headers['content-type'] != 'application/json'){
            return response_data
        }
        let proper_code = ['200', '201']
        if (proper_code.includes(String(response_data.data.code))) {
            return response_data
        }else{
            message.error(response_data.data.message)
            return response_data
        }
        
    }
)


/**
 * RequireManager class ...
 * A wrapper class for managing HTTP requests, implemented based on axios
 * Provides unified request configuration, interceptor handling, and error management mechanism
 * Supports loading state control and custom error prompts
 */
class RequireManager {
    /**
     * The RequireManager constructor method ...
     * @param {String} axios_api - axios api url
    */
    constructor(axios_api) {
        this.axios_api = axios_api;
    }

    /**
     * get request ...
     * @param {String} url - request url
     * @param {Object} params - request params
     * @param {Object} loading - optional loading object setup ...
     * @param {String} error_message - optional error message ...
     * @param {Boolean} count_data - calculation data total length if need ...
     * @returns {Promise<axios.AxiosResponse<any>>}
     */
    async get(url, params, loading = null, error_message = null, count_data = false) {
        let result = null

        // try to get the data ...
        try {
            if (loading) {loading.value = true} // make sure the loading start ...
            result = await axios_service.get(`${this.axios_api}/${url}`, {params: params})
        }
        // when error happened ...
        catch (error) {
            if (error_message) { message.error(error_message) }
        }
        // stop the loading status ...
        finally { if (loading) {loading.value = false} }

        // return the result ...
        if (!result) { message.error(error_message); return null }
        if (result.status !== 200) {message.error(`API ERROR : ${result.status}`)}

        // analyze the result data ...
        return this.analyze_result(result.data, count_data)
    }

    /**
     * post request ...
     * @param {String} url - request url
     * @param {FormData} form_data - request params
     * @param {Object} loading - optional loading object setup ...
     * @param {String} error_message - optional error message ...
     * @param {Boolean} count_data - calculation data total length if need ...
     * @returns {Promise<axios.AxiosResponse<any>>}
     */
    async post(url, form_data, loading = null, error_message = null, count_data = false) {

        let result = null
        // try to get the data ...
        try {
            if (loading) {loading.value = true} // make sure the loading start ...
            result = await axios_service.post(`${this.axios_api}/${url}`, form_data)
        }
        // when error happened ...
        catch (error) {
            if (error_message) { message.error(error_message) }
        }
        // stop the loading status ...
        finally { if (loading) {loading.value = false} }

        // return the result ...
        if (!result) { message.error(error_message); return null }
        if (result.status !== 200) {message.error(`API ERROR : ${result.status}`)}

        // analyze the result data ...
        return this.analyze_result(result.data, count_data)
    }

    /**
     * analyze result data and structure ...
     * @param {Object} result_data - request result object
     * @param {Boolean} count_data - calculation data total length if need ...
     * @returns result data
     */
    analyze_result(result_data, count_data = false) {
        // analyze the result data ...
        if (result_data.code === 200) {
            if (!result_data.data) { return true }
            if (!count_data) { return result_data.data }
            return { total: result_data.total, data: result_data.data }
        }
        else { message.error(result_data.message)}
    }
}


export const require_manager = new RequireManager(AXIOS_API)
export default axios_service
